import React, { useEffect, useRef, useState } from "react";
import { Button, Row, Col, Typography, App, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCalendar,
  markAttendance,
  regularizeAttendance,
  applyLeave,
  addRestrictedHoliday,
  fetchcheckInStatus,
  fetchPendingRequests,
  fetchLeaveDetails,
  fetchHrLocation,
  remoteMarkAttendance,
  fetchAttendanceReport,
  fetchTodaySummary,
  bulkMarkPresent,
  applyShortLeave,  
} from "../attendanceOverviewThunk";
import {
  checkInStatus,
  selectAttendanceCalendar,
  selectleaveDetailsSumary,
  selectHrLocation,
  selectShiftDetails,  
} from "../attendanceOverviewSelectors";
import MarkAttendanceModal from "./modals/MarkAttendanceModal";
import RemoteMarkAttendanceModal from "./modals/RemoteMarkAttendanceModal";
import dayjs from "dayjs";
import RegularizeAttendanceModal from "./modals/RegularizeAttendanceModal";
import LeaveModal from "./modals/LeaveModal";
import ShortLeaveModal from "./modals/ShortLeaveModal";
import RestrictedHolidayModal from "./modals/RestrictedHolidayModal";
import { UAParser } from "ua-parser-js";
import { accessChecker } from "../../../lib/functions";
import { useSearchParams } from "react-router-dom";
import BulkMarkPresentModal from "./modals/BulkMarkPresentModal";
import { fetchAttendance } from "../../AttendanceEntry/attendanceEntryThunk";
import { selectAuthInfo } from "../../Auth/authSelectors";
import { fetchCurrentEmployee } from "../../../store/commonThunks/lookups";
import { selectCurrentEmployee } from "../../../store/commonSelectors/lookupsSelectors";

const { Title } = Typography;

const MarkAttendanceTab = () => {
  const dispatch = useDispatch();
  const { modal } = App.useApp();
  const calendar = useSelector(selectAttendanceCalendar);
  const leaveDetails = useSelector(selectleaveDetailsSumary) || {};
  const hrLocation = useSelector(selectHrLocation) || {};
  const checkIndata = useSelector(checkInStatus) || {};
  const shiftDetails = useSelector(selectShiftDetails);
  const authInfo = useSelector(selectAuthInfo);
  const currentEmployee = useSelector(selectCurrentEmployee);
  const isProbation = currentEmployee?.employeeType === "probationary";

  // Needed to gate Flexi Leave to non-probationary employees in LeaveModal.
  useEffect(() => {
    if (authInfo?.employee_id) {
      dispatch(fetchCurrentEmployee(authInfo.employee_id));
    }
  }, [dispatch, authInfo?.employee_id]);

  const [disabled, setDisabled] = useState(false);
  // Gates the Check In/Out buttons specifically while today's check-in
  // status is being fetched (separate from the slice's shared `loading`
  // flag, which also covers ~15 unrelated thunks and would make the
  // button flicker during unrelated background calls). Without this, the
  // modal opens showing a stale/empty status and the button can be
  // clicked before the real status loads, offering the wrong action.
  const [statusLoading, setStatusLoading] = useState(false);
  const [markModal, setMarkModal] = useState(false);
  const [remoteMarkAttendanceModal, setRemoteMarkAttendanceModal] =
    useState(false);
  const [attendanceRegularizeModal, setAttendanceRegularizeModal] =
    useState(false);
  const [leaveModal, setLeaveModal] = useState(false);
  const [shortLeaveModal, setShortLeaveModal] = useState(false);
  const [restrictedHolidayModal, setRestrictedHolidayModal] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);
  const [userDeviceDetails, setUserDeviceDetails] = useState({});
  const [userLocation, setUserLocation] = useState({});  
  const [userDistance, setUserDistance] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams(); 
  const [gpsLoading, setGpsLoading] = useState(false);
  // const [accuracyWarned, setAccuracyWarned] = useState(false);
  const accuracyWarnedRef = useRef(false);

  

  useEffect(() => {
    // if (authInfo.employee_id != null && authInfo.employee_id !== 0) {
    getUserDeviceDetails();
    // getUserLocation();
    
    // }
  }, []);

  useEffect(() => {
    // Start GPS continuous tracking
    const watchId = startTrackingLocation();

    // set branch (office) location   

    // Clean up when component unmounts
    return () => {
    if (watchId !== null && watchId !== undefined) {
      navigator.geolocation.clearWatch(watchId);
    }
  };
  }, []);

  

  useEffect(() => {
    dispatch(fetchHrLocation());   
  }, [dispatch]);

  useEffect(() => {
    if (userLocation.latitude && hrLocation.latitude) {
      const distance = DistanceBetweenTwoLocations(
        userLocation.latitude,
        userLocation.longitude,
        hrLocation.latitude,
        hrLocation.longitude
      );
      setUserDistance(distance);
    }
  }, [userLocation, hrLocation]);

  // Calculate the distance between two points (in meters)
  const DistanceBetweenTwoLocations = (lat1, lon1, lat2, lon2) => {
    const R = 6371000; // Earth radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c; // Distance in meters
    return distance;
  };

  const getUserDeviceDetails = async () => {
    const parser = new UAParser();
    const result = parser.getResult();
    const userDeviceDetails = {
      browser: result.browser.name || "Unknown", // e.g., "Chrome"
      os: result.os.name || "Unknown", // e.g., "Windows", "iOS"
      deviceType: result.device.type || "Desktop", // e.g., "Mobile", "Tablet", "Desktop"
    };
    setUserDeviceDetails(userDeviceDetails);
  };

  // const getUserLocation = () => {
  //   if (!navigator.geolocation) {
  //     console.error("user denied location");
  //     return;
  //   }
  //   return new Promise((resolve) => {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const payload = {
  //           latitude: position.coords.latitude,
  //           longitude: position.coords.longitude,
  //         };
  //         setUserLocation(payload);
  //         resolve(payload);
  //       },
  //       (error) => {
  //         console.warn("Location access denied:", error);
  //         resolve(null);
  //       }
  //     );
  //   });
  // };


  useEffect(() => {
    const shouldOpen = searchParams.get("markAttendance") === "1";

    if (
      shouldOpen &&
      userDeviceDetails?.deviceType &&
      userLocation?.latitude &&
      userLocation?.longitude &&
      userDistance !== null      
    ) {
      openMark();
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, userDeviceDetails, userLocation, userDistance]);

  // useEffect(() => {
  // const shouldOpen = searchParams.get("markAttendance") === "1";

  // if (shouldOpen && userDeviceDetails?.deviceType) {
  //   openMark(); // 🔥 always call
  //   setSearchParams({}, { replace: true });
  // }
  // }, [searchParams, userDeviceDetails]);



  const startTrackingLocation = () => {
    if (!navigator.geolocation) {
      console.error("Geolocation not supported");
      return null;
    }

    setGpsLoading(true);

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const { latitude, longitude, accuracy } = position.coords;

        setUserLocation({
          latitude,
          longitude,
          accuracy,
        });

        setGpsLoading(false);

        const isMobile =
          userDeviceDetails?.deviceType?.toLowerCase() === "mobile" ||
          userDeviceDetails?.deviceType?.toLowerCase() === "tablet" ||
          /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent);

        // Show low GPS warning only once and only for mobile/tablet
        if (
          isMobile &&
          accuracy > 100 &&
          !accuracyWarnedRef.current
        ) {
          // Set immediately BEFORE opening modal
          accuracyWarnedRef.current = true;

          modal.warning({
            title: "Low GPS Accuracy",
            content:
              "GPS accuracy is low. Please move closer to a window or open area.",
          });
        }
      },
      (error) => {
        setGpsLoading(false);
        console.error("Location error:", error);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 10000,
      }
    );

    return watchId;
  };

  function  getLocationName({ latitude, longitude }) {
    fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    )
      .then((res) => res.json())
      .then((data) => {
      })
      .catch(() => {});
  }


  function formatDistance(meters) {
    const km = Math.floor(meters / 1000);
    const m = (meters % 1000).toFixed(2);
    return `${km} km ${m} m`;
  }

  const openMark = async () => {
    const isMobile =
    userDeviceDetails?.deviceType.toLowerCase() === "mobile" ||
    userDeviceDetails?.deviceType.toLowerCase() === "tablet" ||
    /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent);

    if (!isMobile) {
      modal.error({
        title: "Device Alert",
        content: "You are only allowed to Mark attendance from the mobile app.",
      });
      return;
    }          
       
    if (userDistance === null || isNaN(userDistance)) {
      modal.error({
        title: "Location Error",
        content:
          "Unable to determine your location. Please enable GPS and try again.",
      });

    } else if (userDistance <= 200) {
      // ℹ️ GPS accuracy notice (NON-BLOCKING)
      if (isMobile && userLocation?.accuracy > 100) {
        modal.info({
          title: "GPS Accuracy Notice",
          content: "Attendance allowed, but GPS accuracy is low.",
        });
      }

      setMarkModal(true);
      setStatusLoading(true);
      try {
        await dispatch(fetchcheckInStatus()).unwrap();
      } finally {
        setStatusLoading(false);
      }
    } else {
     
      modal.error({
        title: "Location Verification Required",
        // content: `You are ${userDistance.toFixed(
        //   2
        content: `Attendance can only be marked from within the authorized office premises. Your current location is approximately ${formatDistance(userDistance)} meters away.`,
      });
    }
  };

  const openRemoteMarkAttendance = async () => {
    setRemoteMarkAttendanceModal(true);
    setStatusLoading(true);
    try {
      await dispatch(fetchcheckInStatus()).unwrap();
    } finally {
      setStatusLoading(false);
    }
  };
  const openLeaveModal = async () => {
    setLeaveModal(true);
    await dispatch(fetchLeaveDetails()).unwrap();
  };

  const openShortLeaveModal = async () => {
    setShortLeaveModal(true);
    await dispatch(fetchLeaveDetails()).unwrap();
    await dispatch(fetchcheckInStatus()).unwrap();
  };

  // const disableAllDates = (date) => date.isAfter(dayjs());

  const proceedMarkAttendance =
  async (data) => {
    dispatch(
      markAttendance({
        action: "present",
        notes: data.notes,
      })
    )
  }

  const handleMarkAttendance = async (data) => {
    console.log(data)
    try {
      setDisabled(true);
      if (
        checkIndata?.late_deduction_warning
      ) {

        return modal.confirm({
          title: "Late Deduction Warning",
          content:
            checkIndata
              ?.late_deduction_warning,
          onOk: async () => {
            await proceedMarkAttendance(data);
          },
        });
      }
      await dispatch(markAttendance({ action: "present", date: data.date, time: data.time, notes: data.notes }))
        .unwrap()
        .then((res) => modal.success({ title: res.message }))
        .catch((err) => modal.error({ title: err.message }));
      await Promise.all([
        dispatch(fetchcheckInStatus()).unwrap(),
        dispatch(fetchCalendar()).unwrap(),
        dispatch(fetchAttendanceReport()).unwrap(),
        dispatch(fetchTodaySummary()).unwrap()
      ]);
      setMarkModal(false);
    } catch (err) {
      modal.error({
        title: "Failed to Mark Attendance",
        content: err?.message || "An unexpected error occurred",
      });
    } finally {
      setDisabled(false);
    }
  };

  const handleRemoteMarkAttendance = async (data) => {
    try {
      setDisabled(true);
      await dispatch(
        remoteMarkAttendance({ action: "present", date: data.date, time: data.time, notes: data.notes })
      )
        .unwrap()
        .then((res) => modal.success({ title: res.message }))
        .catch((err) => modal.error({ title: err.message }));
      await Promise.all([
        dispatch(fetchcheckInStatus()).unwrap(),
        dispatch(fetchCalendar()).unwrap(),
        dispatch(fetchTodaySummary()).unwrap()
      ]);

      setRemoteMarkAttendanceModal(false);
    } catch (err) {
      modal.error({ title: "Error", content: err.message });
    } finally {
      setDisabled(false);
    }
  };

  const handleRegularize = async (data) => {
    const { fromDate, toDate, checkIn, checkOut, notes, attendance } = data;
    const isPresent = (attendance || "present") === "present";

    try {
      // 🧠 Validations
      if (!fromDate) return modal.warning({ title: "Select From Date" });
      if (!toDate) return modal.warning({ title: "Select To Date" });

      const formattedFromDate = dayjs(fromDate).format("YYYY-MM-DD");
      const formattedToDate = dayjs(toDate).format("YYYY-MM-DD");

      if (formattedFromDate > formattedToDate)
        return modal.warning({
          title: "The 'From' date cannot be later than the 'To' date.",
        });

      // Check-in/out comparisons only make sense for "present" -- other
      // types (absence/leave) submit no times at all.
      if (isPresent) {
        if (checkIn === checkOut)
          return modal.warning({
            title: "Check-in and check-out times cannot be the same.",
          });

        if (checkIn > checkOut)
          return modal.warning({
            title: "Check-in time cannot be later than check-out time.",
          });
      }

      if (!notes?.trim()) return modal.warning({ title: "Notes is required" });

      setDisabled(true);

      // Build payload
      const payload = {
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        checkIn: isPresent ? checkIn : null,
        checkOut: isPresent ? checkOut : null,
        notes,
        attendance: attendance || "present",
        status: "pending",
      };
      // 🔄 Dispatch API call
      const res = await dispatch(regularizeAttendance(payload)).unwrap();

      modal.success({
        title: res?.message || "Attendance Regularized Successfully",
      });

      await Promise.all([
        dispatch(fetchPendingRequests()).unwrap(),
        dispatch(fetchCalendar()).unwrap(),
      ]);

      setAttendanceRegularizeModal(false);
    } catch (err) {
      modal.error({
        title: "Failed to Regularize Attendance",
        content: err.message || "An unexpected error occurred",
      });
    } finally {
      setDisabled(false);
    }
  };

const handleLeaveSubmit = async ({
  leaveType,
  from_date,
  to_date,
  notes,
  attachments,  // ← NEW
}) => {
  try {
    setDisabled(true);

    const payload = {
      attendance:  leaveType.value,
      from_date,
      to_date,
      notes,
      status:      "pending",
      attachments, // ← NEW
    };

    await dispatch(applyLeave(payload)).unwrap();
    modal.success({ title: "Leave Applied Successfully" });
    setShortLeaveModal(false);
    setLeaveModal(false);
    await Promise.all([
      dispatch(fetchCalendar()).unwrap(),
      dispatch(fetchPendingRequests()).unwrap(),
    ]);
  } catch (err) {
    modal.error({
      title: "Failed to Apply Leave",
      content: err.message || "An unexpected error occurred",
    });
  } finally {
    setDisabled(false);
  }
};

const handleShortLeaveSubmit = async (data) => {
  try {
    setDisabled(true);

    // ── Pass data as-is, thunk handles FormData + authInfo ──
    await dispatch(applyShortLeave(data)).unwrap();

    modal.success({ title: "Short Leave Applied Successfully" });
    setShortLeaveModal(false);

    await Promise.all([
      dispatch(fetchcheckInStatus()).unwrap(),
      dispatch(fetchCalendar()).unwrap(),
      dispatch(fetchPendingRequests()).unwrap(),
    ]);
  } catch (err) {
    modal.error({
      title: "Failed to Apply Short Leave",
      content: err?.message || err || "Unable to apply short leave",
    });
  } finally {
    setDisabled(false);
  }
};

  const handleAddRestrictedHoliday = async ({
    restricted_holiday_date,
    notes,
  }) => {
    try {
      setDisabled(true);
      if (!notes?.trim()) return modal.warning({ title: "Notes is required" });
      const payload = {
        restricted_holiday_date,
        notes,
      };
      await dispatch(addRestrictedHoliday(payload)).unwrap();
      modal.success({ title: "Restricted Holiday Added Successfully" });

      await dispatch(fetchCalendar()).unwrap();
      setRestrictedHolidayModal(false);
    } catch (err) {
      modal.error({
        title: "Failed to Add Restricted Holiday",
        content: err.message || "An unexpected error occurred",
      });
    } finally {
      setDisabled(false);
    }
  };

  const handleBulkMarkPresent = async (data) => {
  try {
    setDisabled(true);

    await dispatch(bulkMarkPresent(data)).unwrap();

    modal.success({ title: "Bulk Present Marked Successfully" });

    await Promise.all([
      dispatch(fetchAttendanceReport()).unwrap(),
      dispatch(fetchTodaySummary()).unwrap(),
      dispatch(fetchCalendar()).unwrap(),
    ]);    

    setBulkModal(false);
  } catch (err) {
    modal.error({
      title: "Failed to Mark Bulk Present",
      content: err.message,
    });
  } finally {
    setDisabled(false);
  }
};

    return (
  <div className="attendance-dashboard">

    {/* GPS Loader */}
    {gpsLoading && (
      <div className="attendance-gps-loader">
        <Spin tip="Fetching GPS location..." />
      </div>
    )}

    {/* =======================================================
          TODAY SNAPSHOT
    ======================================================= */}

    <div className="attendance-card attendance-summary-card">

      <div className="attendance-card-header">
        <Title level={4} style={{ marginBottom: "16px" }}>
        Mark Attendance
      </Title>
      </div>

      

    </div>





    {/* =======================================================
            QUICK ACTIONS
    ======================================================= */}

    <div className="attendance-card">     
      <Row gutter={[16,16]} style={{ marginBottom: "32px" }}>
        <Col>
          <Button
            className="attendance-action-btn"
            onClick={openMark}
          >
            ➕ Mark Attendance
          </Button>
        </Col>

        <Col>
          <Button
            className="attendance-action-btn"
            onClick={openRemoteMarkAttendance}
            data-testid="remote_mark_attendance"
          >
            🏠 Remote Attendance
          </Button>
        </Col>

        <Col>
          <Button
            className="attendance-action-btn"
            onClick={() => setAttendanceRegularizeModal(true)}
            data-testid="attendance_regularization"
          >
            🕓 Regularization
          </Button>
        </Col>

        <Col>
          <Button
            className="attendance-action-btn"
            onClick={openLeaveModal}
            data-testid="leave"
          >
            🌴 Leave
          </Button>
        </Col>

        <Col>
          <Button
            className="attendance-action-btn"
            onClick={openShortLeaveModal}
            data-testid="short_leave"
          >
            ⏱ Short Leave
          </Button>
        </Col>

        {accessChecker("approve_attendance") && (

          <Col>

            <Button
              className="attendance-action-btn"
              onClick={() => setRestrictedHolidayModal(true)}
            >
              📅 Restricted Holiday
            </Button>

          </Col>

        )}

        {accessChecker("approve_attendance") && (

          <Col>

            <Button
              className="attendance-action-btn"
              onClick={() => setBulkModal(true)}
              data-testid="bulk_mark_present"
            >
              👥 Bulk Present
            </Button>

          </Col>

        )}

      </Row>

    </div>



    {/* =======================================================
           KEEP ALL MODALS BELOW THIS
    ======================================================= */}

    <MarkAttendanceModal
      visible={markModal}
      onClose={() => setMarkModal(false)}
      onMarkAttendance={handleMarkAttendance}
      checkInTime={checkIndata?.check_in}
      checkOutTime={checkIndata?.check_out}
      isDisabled={disabled}
      statusLoading={statusLoading}
      userDistance={userDistance}
      shiftDetails={shiftDetails}
      existingShortLeave={checkIndata?.existing_short_leave}
    />

    <RemoteMarkAttendanceModal
      visible={remoteMarkAttendanceModal}
      onClose={() => setRemoteMarkAttendanceModal(false)}
      onRemoteMark={handleRemoteMarkAttendance}
      checkInTime={checkIndata?.check_in}
      checkOutTime={checkIndata?.check_out}
      shiftDetails={shiftDetails}
      existingShortLeave={checkIndata?.existing_short_leave}
      isDisabled={disabled}
      statusLoading={statusLoading}
    />

    <RegularizeAttendanceModal
      visible={attendanceRegularizeModal}
      onClose={() => setAttendanceRegularizeModal(false)}
      onRegularize={handleRegularize}
      isDisabled={disabled}
    />

    <LeaveModal
      visible={leaveModal}
      onClose={() => setLeaveModal(false)}
      onLeaveSubmit={handleLeaveSubmit}
      restrictedHolidays={calendar?.restricted_holidays}
      weekEndDays={calendar?.weekendDays?.[0]?.weekend_days || []}
      leaveDetailsSummary={leaveDetails}
      totalLeaveTaken={leaveDetails.totalLeaveTaken}
      leaveRemainingBalance={leaveDetails.remainingLeave}
      isDisabled={disabled}
      isProbation={isProbation}
      isIndia={authInfo?.country === "India"}
    />

    <ShortLeaveModal
      visible={shortLeaveModal}
      onClose={() => setShortLeaveModal(false)}
      onShortLeaveSubmit={handleShortLeaveSubmit}
      restrictedHolidays={calendar?.restricted_holidays}
      weekEndDays={calendar?.weekendDays?.[0]?.weekend_days || []}
      totalLeaveTaken={leaveDetails.totalLeaveTaken}
      leaveRemainingBalance={leaveDetails.remainingLeave}
      leaveDetailsSummary={leaveDetails}
      existingAttendance={checkIndata}
      existingShortLeave={checkIndata?.existing_short_leave}
      isDisabled={disabled}
    />

    <RestrictedHolidayModal
      visible={restrictedHolidayModal}
      onClose={() => setRestrictedHolidayModal(false)}
      onAddRestrictedHoliday={handleAddRestrictedHoliday}
      isDisabled={disabled}
    />

    <BulkMarkPresentModal
      visible={bulkModal}
      onClose={() => setBulkModal(false)}
      onSubmit={handleBulkMarkPresent}
      restrictedHolidays={calendar?.restricted_holidays}
      weekEndDays={calendar?.weekendDays?.[0]?.weekend_days || []}
      isDisabled={disabled}
    />

  </div>
);
}

export default MarkAttendanceTab;
